/**
 * The `mediaText` Alpine component for og/sections-media-text: the video
 * lightbox. The thumbnail is a link to the video (complete without JS); a
 * click opens the <dialog> and copies the player in from its <template>.
 * Closing empties the player, which stops playback. Registered inside
 * alpine:init; resources/js/app.js starts Alpine.
 */
import Alpine from 'alpinejs';

document.addEventListener( 'alpine:init', () => {
	Alpine.data( 'mediaText', () => ( {
		open( event ) {
			const { dialog, player, source } = this.$refs;

			if ( ! dialog?.showModal || ! source ) {
				return;
			}

			event.preventDefault();
			player.replaceChildren( source.content.cloneNode( true ) );
			dialog.showModal();
		},

		close() {
			this.$refs.dialog?.close();
		},

		// A click on the backdrop lands on the dialog itself.
		dismiss( event ) {
			if ( event.target === this.$refs.dialog ) {
				this.close();
			}
		},

		unload() {
			this.$refs.player?.replaceChildren();
		},
	} ) );
} );
